import {create} from 'zustand';
import {customerApi} from '../services/api/customerApi';

export const useCustomerStore = create((set, get) => ({
  customers: [],
  currentCustomer: null,
  isLoading: false,
  searchQuery: '',
  pagination: {page: 0, size: 20, totalElements: 0, totalPages: 0},
  referralSources: [],
  customerStats: null,

  fetchCustomers: async (params = {}) => {
    set({isLoading: true});
    try {
      const response = await customerApi.list({
        page: params.page || 0,
        size: params.size || 20,
        ...params,
      });
      const data = response.data.data;
      set({
        customers: data.content,
        pagination: {
          page: data.page,
          size: data.size,
          totalElements: data.totalElements,
          totalPages: data.totalPages,
        },
      });
    } finally {
      set({isLoading: false});
    }
  },

  searchCustomers: async query => {
    set({isLoading: true, searchQuery: query});
    try {
      const response = await customerApi.search(query);
      set({customers: response.data.data.content || response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  fetchCustomerDetail: async id => {
    set({isLoading: true});
    try {
      const response = await customerApi.getById(id);
      set({currentCustomer: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  createCustomer: async data => {
    const response = await customerApi.create(data);
    const newCustomer = response.data.data;
    set(state => ({customers: [newCustomer, ...state.customers]}));
    return newCustomer;
  },

  updateCustomer: async (id, data) => {
    const response = await customerApi.update(id, data);
    const updated = response.data.data;
    set(state => ({
      customers: state.customers.map(c => (c.id === id ? updated : c)),
      currentCustomer:
        state.currentCustomer?.id === id ? updated : state.currentCustomer,
    }));
    return updated;
  },

  deleteCustomer: async id => {
    await customerApi.delete(id);
    set(state => ({
      customers: state.customers.filter(c => c.id !== id),
      currentCustomer:
        state.currentCustomer?.id === id ? null : state.currentCustomer,
    }));
  },

  clearCurrentCustomer: () => set({currentCustomer: null}),

  fetchCustomerStats: async id => {
    try {
      const response = await customerApi.getStats(id);
      set({customerStats: response.data.data});
    } catch (e) {
      console.warn('Failed to fetch customer stats:', e.response?.status, e.message);
    }
  },

  clearCustomerStats: () => set({customerStats: null}),

  fetchReferralSources: async () => {
    try {
      const response = await customerApi.getReferralSources();
      const sources = response.data.data || [];
      console.log('Fetched referral sources:', sources.length, sources);
      set({referralSources: sources});
    } catch (e) {
      console.warn('Failed to fetch referral sources:', e.response?.status, e.message);
    }
  },

  uploadCustomerImages: async (id, faceImage, bodyImage) => {
    const formData = new FormData();
    if (faceImage) {
      formData.append('faceImage', {
        uri: faceImage.uri,
        type: faceImage.type || 'image/jpeg',
        name: faceImage.fileName || 'face.jpg',
      });
    }
    if (bodyImage) {
      formData.append('bodyImage', {
        uri: bodyImage.uri,
        type: bodyImage.type || 'image/jpeg',
        name: bodyImage.fileName || 'body.jpg',
      });
    }
    const response = await customerApi.uploadImages(id, formData);
    return response.data.data;
  },
}));
